import { BuilderElement } from "@/types/elements";

export const BLANK_ELEMENT: Omit<BuilderElement, "slug" | "name"> = {
  className: false,
  uiIcon: false,
  category: "other",
  badge: false,
  htmlTag: {
    default: "div",
    options: [],
    pathToControl: false
  },
  template: "Blank Element",
  attributes: false,
  cssTemplate: "%%SELECTOR%% { }",
  defaultCss: " ", // If it's empty PHP errors when creating the file even tho it works.
  defaultProperties: false,
  defaultChildren: false,
  controls: { contentSections: [], designSections: [], settingsSections: [] },
  dependencies: false,
  actions: false,
  nestingRule: { type: "final" },
  spacingBars: false,
  dynamicPropertyPaths: false,
  settings: false,
  addPanelRules: false,
  experimental: false,
  availableIn: ["breakdance"],
  order: 0,
  additionalClasses: false,
  projectManagement: false,
  propertyPathsToWhitelistInFlatProps: false,
  propertyPathsToSsrElementWhenValueChanges: false
};
